import { del, get, patch, post, qs } from './http.ts';

export interface SessionItem {
  id: string;
  kind: 'web' | 'desktop';
  device_name: string | null;
  platform: string | null;
  user_agent: string | null;
  ip: string | null;
  created_at: string;
  last_used_at: string | null;
  expires_at: string;
  is_current: boolean;
}

export interface NotificationItem {
  id: string;
  kind: string;
  title: string;
  body: string | null;
  link: string | null;
  read_at: string | null;
  created_at: string;
}

export interface SecurityEvent {
  action: string;
  meta: Record<string, unknown>;
  ip: string | null;
  user_agent: string | null;
  created_at: string;
}

export const listSessions = (): Promise<{ items: SessionItem[] }> => get('/account/sessions');

export const revokeSession = (id: string): Promise<{ ok: boolean }> =>
  del(`/account/sessions/${id}`);

export const revokeOtherSessions = (): Promise<{ revoked: number }> =>
  post('/account/sessions/revoke-others');

export const updateProfile = (displayName: string): Promise<{ ok: boolean }> =>
  patch('/account/profile', { display_name: displayName });

export const securityLog = (): Promise<{ items: SecurityEvent[] }> =>
  get('/account/security-log?limit=50');

// ── 앱 비밀번호 (WebDAV 연결용) ──────────────────────────────────────────────

export interface AppPassword {
  id: string;
  label: string;
  scope: string;
  created_at: string;
  last_used_at: string | null;
  last_used_ip: string | null;
  expires_at: string | null;
}

/** 발급 응답에만 password 가 들어 있다. 서버는 해시만 보관한다. */
export interface NewAppPassword extends AppPassword {
  password: string;
}

export const listAppPasswords = (): Promise<{ items: AppPassword[] }> =>
  get('/account/app-passwords');

export const createAppPassword = (label: string): Promise<NewAppPassword> =>
  post('/account/app-passwords', { label });

export const deleteAppPassword = (id: string): Promise<{ ok: boolean }> =>
  del(`/account/app-passwords/${id}`);

export const listNotifications = (
  unread = false,
): Promise<{ items: NotificationItem[]; unread_count: number }> =>
  get(`/notifications${qs({ unread, limit: 50 })}`);

export const markNotificationsRead = (
  body: { ids?: string[]; all?: boolean },
): Promise<{ marked: number }> => post('/notifications/read', body);
